import { ALTERAR_MAPA_SELECIONADO_VEICULO } from '../../actions/types'

const initialState = null

export default function reducerAlterarMapaSelecionadoVeiculo (state = initialState, action) {
  switch (action.type) {
    case ALTERAR_MAPA_SELECIONADO_VEICULO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}